<div class="tp-card">
  <div class="tp-toolbar">
    <div class="tp-search">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="20" y1="20" x2="16.65" y2="16.65"></line></svg>
      <input type="text" [value]="searchQuery" (input)="onSearch($event)" placeholder="Rechercher" />
    </div>

    <div class="tp-filter-wrap">
      <button type="button" class="tp-filter-btn" [class.is-active]="showFilters" (click)="showFilters = !showFilters">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
        Filtres
        <span *ngIf="activeFilterCount" class="tp-filter-dot"></span>
      </button>

      <ng-container *ngIf="showFilters">
        <div class="tp-filter-backdrop" (click)="showFilters = false"></div>
        <div class="tp-filter-panel">
          <label for="rb-status">Statut</label>
          <select id="rb-status" [(ngModel)]="statusFilter" (ngModelChange)="applyFilters()">
            <option *ngFor="let s of statusOptions" [ngValue]="s.value">{{ s.label }}</option>
          </select>

          <label for="rb-ticket">Titre</label>
          <select id="rb-ticket" [(ngModel)]="ticketFilter" (ngModelChange)="applyFilters()">
            <option [ngValue]="''">Tous les titres</option>
            <option *ngFor="let t of ticketOptions" [ngValue]="t.id">{{ t.label }}</option>
          </select>

          <button type="button" class="tp-filter-reset" (click)="resetFilters()">Réinitialiser</button>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="tp-table-wrap">
    <table class="tp-table">
      <thead>
        <tr>
          <th style="width: 12%">N°</th>
          <th style="width: 22%">Titre</th>
          <th style="width: 15%">Expéditeur</th>
          <th style="width: 20%">Date</th>
          <th style="width: 14%" class="col-center">Montant</th>
          <th style="width: 17%">Statut</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of pagedData; trackBy: trackById">
          <td class="tp-id">{{ row.id }}</td>
          <td><span class="tp-chip">{{ ticketLabel(row.ticketId) }}</span></td>
          <td>{{ row.from || '—' }}</td>
          <td class="tp-date">{{ row.date | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td class="col-center tp-amount">{{ formatAmount(rowAmount(row)) }}</td>
          <td>
            <span class="tp-badge tp-badge--{{ statusKind(row.status) }}">
              <svg *ngIf="statusKind(row.status) === 'success'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <svg *ngIf="statusKind(row.status) === 'danger'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              <svg *ngIf="statusKind(row.status) === 'pending'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>
              {{ statusLabel(row.status) }}
            </span>
          </td>
        </tr>
        <tr *ngIf="!filteredData.length">
          <td colspan="6" class="tp-empty">Aucun remboursement trouvé.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="tp-footer">
    <span>Affichage de {{ rangeStart }} à {{ rangeEnd }} sur {{ filteredData.length }} entrées</span>
    <div class="tp-pager">
      <button type="button" class="tp-page-btn" [disabled]="page === 1" (click)="goTo(page - 1)">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </button>
      <button type="button" *ngFor="let p of pages" class="tp-page-btn" [class.is-current]="p === page" (click)="goTo(p)">{{ p }}</button>
      <button type="button" class="tp-page-btn" [disabled]="page === totalPages" (click)="goTo(page + 1)">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
      </button>
    </div>
  </div>
</div>